/**
 * Pick the singular or plural form of a noun for a count. Returns the NOUN
 * only, not the count, so a caller keeps control of the surrounding markup —
 * the provider page renders the number in its own <span> (VIT-18198).
 *
 * English-only by design: atlas-web is a US site, so `Intl.PluralRules` buys
 * nothing over `count === 1` here and would still need per-locale noun forms.
 *
 * `Math.abs` because a count is only ever singular at exactly one of something:
 * "-1 review", not "-1 reviews". No caller passes a negative today, but the
 * alternative silently reads wrong if one ever does.
 */
export const pluralize = (count: number, singular: string, plural = `${singular}s`): string =>
  Math.abs(count) === 1 ? singular : plural
